import { render, staticRenderFns } from "./activity-stream-component.vue?vue&type=template&id=a85abdd4&scoped=true"
import script from "./activity-stream-component.ts?vue&type=script&lang=ts&external"
export * from "./activity-stream-component.ts?vue&type=script&lang=ts&external"
import style0 from "./activity-stream-component.scss?vue&type=style&index=0&id=a85abdd4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85abdd4",
  null
  
)

export default component.exports